import apiWorker from '../apiWorker'

const load = {
    standard: () => apiWorker('get',  `/v1/load/standard`, null, true),
}

export default load;